import React from "react";
import AuditTrail from "../../../../components/AuditTrail";
import { ApiURL } from "../../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.sulphur_record_bd_log_com} />;
}
